import React from "react";
import { useAuth } from "../context/AuthContext";
import { Eye, X } from "lucide-react";

/**
 * Phase 19.28 — fixed top banner shown only when the platform admin has flipped
 * the "View as Customer" toggle. Click X to exit and return to the Owner Console.
 */
export default function CustomerViewBanner() {
  const { user, adminViewAsCustomer, setAdminViewAsCustomer } = useAuth();
  if (!user?.is_platform_admin || !adminViewAsCustomer) return null;

  const exit = () => {
    setAdminViewAsCustomer(false);
    window.location.href = "/admin";
  };

  return (
    <div
      className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-3 shadow-sm"
      data-testid="customer-view-mode-banner"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="w-4 h-4" />
        <span>
          <strong>Customer View Mode</strong> — you're seeing what your subscribers see. Your edits affect real data.
        </span>
      </div>
      <button
        onClick={exit}
        className="flex items-center gap-1.5 text-xs font-semibold bg-amber-900/15 hover:bg-amber-900/25 rounded px-2.5 py-1 transition"
        data-testid="customer-view-exit-btn"
      >
        Exit Customer View <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
